// surfeys/surveySelectUtils.js
export const getAnswerSelect = (select, answerId) => {
    return select && select.codeableId === answerId ? select : null;
};
  